<template>
    <v-chart ref="chart" :options="computedOptions" :style="{ width, height }" auto-resize @click="handleClick" />
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts';
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default {
    name: 'PieChart',
    components: { 'v-chart': ECharts },
    props: {
        data: { type: Array, required: true, default: () => [] },
        width: { type: String, default: '100%' },
        height: { type: String, default: '400px' },
        title: { type: String, default: '' },
        showLegend: { type: Boolean, default: true },
        colors: { type: Array, default: () => ["#3B64F6", "#44EFE1", "#5AFF9F", "#D4D7D0", "#FF9900"] },
        radius: { type: [Array, String], default: () => ['40%', '70%'] },
        showLabel: { type: Boolean, default: true },
        showPercent: { type: Boolean, default: true }
    },
    data() {
        return {
            pieData: []
        }
    },
    computed: {
        validData() {
            return (this.data || []).filter(
                item => item && item.name != null && item.value != null
            ).map(item => ({
                name: String(item.name),
                value: typeof item.value === 'number' ? item.value : Number(item.value) || 0
            }))
        },
        computedOptions() {
            if (this.validData.length === 0) {
                return { tooltip: {}, series: [] }
            }

            return {
                // title: this.title
                //     ? { text: this.title, left: 'center', textStyle: { fontSize: 16 } }
                //     : undefined,
                color: this.colors.length > 0 ? this.colors : undefined,
                tooltip: { trigger: 'item' },
                legend: this.showLegend
                    ? {
                        right: "8",
                        bottom: "5%",
                        // align: "right",
                        orient: "vertical",
                        itemGap: 18,
                        itemWidth: 8,
                        itemHeight: 8,
                        shadowBlur: 10,
                        shadowOffsetY: 0,
                        shadowOffsetX: 0,
                        borderColor: "#2a2a34",
                        borderWidth: 1,
                        textStyle: {
                            color: "#fff",
                            fontFamily: "钉钉进步体 Regular",
                        },
                        data: this.validData.map(item => item.name)
                    }
                    : undefined,
                // color: [],
                series: [
                    {
                        type: "pie",
                        // z: 3,
                        // roundCap: true,
                        radius: ["35%", "55%"],
                        center: ["50%", "45%"],
                        label: {
                            show: true,
                            position: "outside",
                            color: "#18FEFE",
                            fontFamily: "钉钉进步体 Regular",
                            formatter: function (params) {
                                return (
                                    // params.value +
                                    // "\n" +
                                    params.percent.toFixed(1) +
                                    "%"
                                );
                            },
                        },
                        // labelLine: {
                        //     length: 30,
                        //     length2: 100,
                        //     show: true,
                        //     color: "#00ffff",
                        // },
                        data: this.getPieData(),
                    }]
            }
        }
    },
    methods: {
        handleClick(params) {
            this.$emit('chart-click', params)
        },
        getChartInstance() {
            return this.$refs.chart?.chartInstance
        },
        getPieData() {
            let pieData = []
            for (let i = 0; i < this.data.length; i++) {
                pieData.push({
                    ...this.data[i],
                    itemStyle: {
                        borderRadius: 2,
                        shadowColor: "#2a2a34",
                        shadowBlur: 2,
                        shadowOffsetY: 0,
                        shadowOffsetX: 0,
                        borderColor: "#2a2a34",
                        borderWidth: 2,
                    },
                });
            }
            return pieData
        },
    }
}
</script>